import React from 'react';

import Link from '../editor/Link'

const BEmbedCarouselEditor = (props) => {
    return (
        <div>
            {props.children}
            <Link value={props.settings.link} />
            <hr />
            <div className="form-group">
                <label className="col-sm-3 control-label">Opis</label>
                <div className="col-sm-9">
                    <input type="text" name="description" className="form-control" defaultValue={props.settings.description} placeholder="Opis" />
                </div>
            </div>
        </div>
    );
}


export default BEmbedCarouselEditor;